import { Base } from '@studiometa/js-toolkit';

/**
 * DarkModeInput component
 */
export default class HighContrastModeInput extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'HighContrastModeInput',
  };

  /**
   * isDarkMode
   * @returns {string}
   */
  get isHighContrastMode() {
    return localStorage.getItem('highcontrastmode') === '1';
  }

  /**
   * mounted
   */
  mounted() {
    if (this.isHighContrastMode) {
      this.$el.checked = true;
    }
  }

  /**
   * onChange
   */
  onChange() {
    if (this.$el.checked) {
      document.scrollingElement.classList.add('highcontrast');
      localStorage.setItem('highcontrastmode', '1');
    } else {
      document.scrollingElement.classList.remove('highcontrast');
      localStorage.setItem('highcontrastmode', '0');
    }
  }
}
